import { render } from "./material-modal.vue?vue&type=template&id=6535f728&ts=true"
import script from "./material-modal.vue?vue&type=script&lang=ts"
export * from "./material-modal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__